module.exports = __webpack_public_path__ + "public/files/img/students.834545b4.gif";